import atendimentoDomiciliarRepository from "./atendimentoDomiciliarRepository"
import atendimentoIndividualRepository from "./atendimentoIndividualRepository"
import atendimentoOdontologicoRepository from "./atendimentoOdontologicoRepository"
import atividadeColetivaRepository from "./atividadeColetivaRepository"
import avaliacaoRepository from "./avaliacao"
import cadastroDomiciliarRepository from "./cadastroDomiciliarRepository"
import cadastroIndividualRepository from "./cadastroIndividualRepository"
import exportacaoRepository from "./exportacaoRepository"
import fichaComplementarRepository from "./fichaComplementarRepository"
import fichaVacinacaoRepository from "./fichaVacinacaoRepository"
import mapaAtendimentoRepository from "./mapaAtendimentoRepository"
import marcadorConsumoAlimentar from "./marcadorConsumoAlimentarRepository"
import parametrizacaoRepository from "./parametrizacaoRepository"
import procedimentoRepository from "./procedimentoRepository"
import relatorioAcessoCuidadoProgramadoRepository from "./relatorioAcessoCuidadoProgramadoRepository"
import relatorioAtendimentoDomiciliarRepository from "./relatorioAtendimentoDomiciliarRepository"
import relatorioAtendimentoOdontologico from "./relatorioAtendimentoOdontologico"
import relatorioCadastroConsistenteRepository from "./relatorioCadastroConsistenteRepository"
import relatorioCuidadoDesenvolvimentoInfantilRepository from "./relatorioCuidadoDesenvolvimentoInfantilRepository"
import relatorioCuidadoGestacaoPuerperioRepository from "./relatorioCuidadoGestacaoPuerperioRepository"
import relatorioCuidadoMulherPrevencaoCancerRepository from "./relatorioCuidadoMulherPrevencaoCancerRepository"
import relatorioCuidadoPessoaComDiabeteRepository from "./relatorioCuidadoPessoaComDiabeteRepository"
import relatorioCuidadoPessoaHipertensaoRepository from "./relatorioCuidadoPessoaHipertensaoRepository"
import relatorioCuidadoPessoaIdosaRepository from "./relatorioCuidadoPessoaIdosaRepository"
import relatorioEstatisticoAtendimento from "./relatorioEstatisticoAtendimentoRepository"
import relatorioEstatisticoPacienteCadastradoRepository from "./relatorioEstatisticoPacienteCadastradoRepository"
import relatorioInconsistenciaRepository from "./relatorioInconsistenciaRepository"
import relatorioIndicadorSadRepository from "./relatorioIndicadorSadRepository"
import relatorioVisitaDomiciliarRepository from "./relatorioVisitaDomiciliarRepository"
import visitaDomiciliarRepository from "./visitaDomiciliarRepository"
import relatorioAtividadeColetivaRepository from "./relatorioAtividadeColetivaRepository"

export default baseUrl => {
    baseUrl = `${baseUrl}/atencao-basica`

    return {
        atendimentoDomiciliar: atendimentoDomiciliarRepository(baseUrl),
        atendimentoIndividual: atendimentoIndividualRepository(baseUrl),
        atendimentoOdontologico: atendimentoOdontologicoRepository(baseUrl),
        atividadeColetiva: atividadeColetivaRepository(baseUrl),
        avaliacao: avaliacaoRepository(baseUrl),
        cadastroDomiciliar: cadastroDomiciliarRepository(baseUrl),
        cadastroIndividual: cadastroIndividualRepository(baseUrl),
        exportacao: exportacaoRepository(baseUrl),
        fichaComplementar: fichaComplementarRepository(baseUrl),
        fichaVacinacao: fichaVacinacaoRepository(baseUrl),
        mapaAtendimento: mapaAtendimentoRepository(baseUrl),
        marcadorConsumoAlimentar: marcadorConsumoAlimentar(baseUrl),
        parametrizacao: parametrizacaoRepository(baseUrl),
        procedimento: procedimentoRepository(baseUrl),
        relatorioAcessoCuidadoProgramado: relatorioAcessoCuidadoProgramadoRepository(baseUrl),
        relatorioAtendimentoDomiciliar: relatorioAtendimentoDomiciliarRepository(baseUrl),
        relatorioAtendimentoOdontologico: relatorioAtendimentoOdontologico(baseUrl),
        relatorioCadastroConsistente: relatorioCadastroConsistenteRepository(baseUrl),
        relatorioCuidadoDesenvolvimentoInfantil: relatorioCuidadoDesenvolvimentoInfantilRepository(baseUrl),
        relatorioCuidadoGestacaoPuerperio: relatorioCuidadoGestacaoPuerperioRepository(baseUrl),
        relatorioCuidadoMulherPrevencaoCancer: relatorioCuidadoMulherPrevencaoCancerRepository(baseUrl),
        relatorioCuidadoPessoaComDiabete: relatorioCuidadoPessoaComDiabeteRepository(baseUrl),
        relatorioCuidadoPessoaHipertensao: relatorioCuidadoPessoaHipertensaoRepository(baseUrl),
        relatorioCuidadoPessoaIdosa: relatorioCuidadoPessoaIdosaRepository(baseUrl),
        relatorioEstatisticoAtendimento: relatorioEstatisticoAtendimento(baseUrl),
        relatorioEstatisticoPacienteCadastrado: relatorioEstatisticoPacienteCadastradoRepository(baseUrl),
        relatorioInconsistencia: relatorioInconsistenciaRepository(baseUrl),
        relatorioIndicadorSad: relatorioIndicadorSadRepository(baseUrl),
        relatorioVisitaDomiciliar: relatorioVisitaDomiciliarRepository(baseUrl),
        visitaDomiciliar: visitaDomiciliarRepository(baseUrl),
        relatorioAtividadeColetiva: relatorioAtividadeColetivaRepository(baseUrl)
    }
}
